<template lang="pug">
  div.p-wrapper
    div.p-box(
      :style="{width: processPercent + '%'}"
    )
</template>
<script>
export default {
  props: {
    processPercent: {
      type: Number,
      default: 0
    }
  }
}
</script>
<style lang="scss" scoped>
.p-wrapper {
  width: 100%;
  height: 8px;
  background: #dcdfe5;
  border-radius: 10px;
  .p-box {
    width: 50%;
    height: 100%;
    background: #2962ff;
    border-radius: 10px;
    transition: width 0.2s linear;
  }
}
</style>
